import {
  AddShoppingCart,
  CheckOutlined,
  Clear,
  ErrorOutline,
  HelpOutline,
  NavigateNext,
} from "@mui/icons-material";
import {
  Typography,
  Box,
  Table,
  TableRow,
  TableCell,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Breadcrumbs,
  TableBody,
  Switch,
  FormControlLabel,
  AccordionDetails,
  Stack,
  Accordion,
  AccordionSummary,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  TableHead,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { environment } from "env";
import EasyRequestService from "modules/EasyRequest/service/easyRequest.service";
import { PUIContentCarousel } from "modules/UI/components/ContentCarousel.component";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { PslMaterial } from "../domains/pslMaterial.domain";
import Drawer from "modules/UI/components/Drawer.component";
import StaticResources from "service/dummyData/resources";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { BarcodeButton } from "modules/UI/components/BarcodeButton.component";
import { useActiveUser } from "../../User/activeUser";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useCart } from "../containers/cart.container";
import { useFeatures } from "modules/FeatureManagement/service/featureManagement.hooks";

export const PromoItemDetails = ({
  open,
  onClose,
  promoItem,
}: {
  open?: boolean;
  onClose?: () => void;
  promoItem: any;
}) => {
  console.log("promoItem:", promoItem);
  const [showEmptyFields, setShowEmptyFields] = useState<boolean>(false);
  const [materialDescriptionExpanded, setMaterialDescriptionExpanded] =
    useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const queryClient = useQueryClient();
  const { cart, addMaterial } = useCart();
  const features = useFeatures();
  const [quantity, setQuantity] = useState(promoItem?.minimumOrderQuantity);
  const [unitPrice, setUnitPrice] = useState(0);
  const [pricePer, setPricePer] = useState(0);
  const [showQuantityError, setShowQuantityError] = useState(false);
  useEffect(() => {
    setShowQuantityError(
      promoItem?.minimumOrderQuantity > quantity ||
      quantity % promoItem?.minimumPurchaseQuantity !== 0
    );
    const pricesRanges = promoItem?.priceRanges
      ?.sort((a, b) => a.quantity - b.quantity)
      ?.reverse()
      ?.find((range) => range.quantity <= quantity);
    setUnitPrice(pricesRanges?.price);
    setPricePer(pricesRanges?.pricePer);
  }, [quantity]);
  useEffect(() => {
    setQuantity(promoItem?.minimumOrderQuantity);
    setMaterialDescriptionExpanded(false);
  }, [promoItem]);
  const activeUser = useActiveUser();
  const { mutateAsync: addToCart, status: addToCartStatus } = useMutation({
    mutationKey: ["addToCart", promoItem?.materialId],
    mutationFn: async () => {
      return EasyRequestService.addPslMaterialById({
        materialId: promoItem?.materialId,
        quantity,
      });
    },
    onSuccess: (res) => {
      queryClient.refetchQueries({ queryKey: ["easyRequestCounter"] });
      const prNumber = (features["easy-request-v3"] ? res?.prId : res[0].prId) || "";
      toast.success(
        `Material added to PR ${prNumber}. Click here to see Cart.`,
        {
          onClick: () => {
            window.open(environment.EASY_REQUEST_URL, "_blank");
          },
        }
      );
    },
  });
  return (
    <Drawer
      open={open}
      onClose={() => onClose()}
      headerContent={<></>}
      footerContent={
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {!!promoItem &&
            !!unitPrice &&
            !!promoItem?.currencyCode &&
            !!pricePer &&
            !!promoItem?.unitOfMeasure && (
              <Tooltip
                placement="bottom-end"
                arrow
                title={`${quantity} ${promoItem.unitOfMeasure} x ${[...promoItem.priceRanges]
                  .sort((a, b) => {
                    return a.quantity < b.quantity ? 1 : -1;
                  })
                  .find((r) => quantity >= r.quantity)?.price
                  } ${promoItem.currencyCode} / ${[...promoItem.priceRanges]
                    .sort((a, b) => {
                      return a.quantity < b.quantity ? 1 : -1;
                    })
                    .find((r) => quantity >= r.quantity)?.pricePer
                  }`}
              >
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "left",
                    fontSize: 18,
                  }}
                >Quantity: {quantity} {promoItem.unitOfMeasure}<br />Total Price:{" "}
                  {Intl.NumberFormat(undefined, {
                    style: "currency",
                    currency: promoItem.currencyCode,
                  }).format(
                    (quantity *
                      [...promoItem.priceRanges]
                        .sort((a, b) => {
                          return a.quantity < b.quantity ? 1 : -1;
                        })
                        .find((r) => quantity >= r.quantity)?.price) /
                    [...promoItem.priceRanges]
                      .sort((a, b) => {
                        return a.quantity < b.quantity ? 1 : -1;
                      })
                      .find((r) => quantity >= r.quantity)?.pricePer
                  )}
                </Typography>
              </Tooltip>
              // <Typography
              //   variant="h6"
              //   sx={{
              //     fontWeight: "bold",
              //     flexGrow: "0",
              //     textOverflow: "ellipsis",
              //     overflow: "hidden",
              //     maxWidth: "100%",
              //     display: "block",
              //   }}
              // >
              //   {unitPrice} {promoItem?.currencyCode} per {pricePer}{" "}
              //   {promoItem?.unitOfMeasure}
              // </Typography>
            )}
          {!!promoItem &&
            PslMaterial.build(promoItem).canBeRequested() &&
            !activeUser.isViewOnly() &&
            activeUser.isMember() && (
              <Box sx={{ ml: "auto", display: "flex", flexDirection: "column", gap: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  startIcon={
                    {
                      pending: <CircularProgress size={14} />,
                      success: <CheckOutlined />,
                      error: <ErrorOutline />,
                    }[addToCartStatus] || <AddShoppingCart />
                  }
                  disabled={addToCartStatus === "pending" || showQuantityError}
                  onClick={() => {
                    addToCart();
                    onClose();
                  }}
                >
                  Add To Cart
                </Button>
                {features["enableV2"] && (
                  <Button
                    variant="outlined"
                    size="large"
                    color="primary"
                    startIcon={<AddShoppingCart />}
                    disabled={showQuantityError}
                    onClick={() => {
                      addMaterial(promoItem, quantity);
                      onClose();
                    }}
                  >
                    Add To Basket
                  </Button>
                )}
              </Box>
            )}
        </Box>
      }
    >
      {" "}
      {!!promoItem && (
        <Box>
          <Box sx={{ mt: -2, mx: -2 }}>
            {/* <PUIContentCarousel
              data={(() => {
                // Use child media files if available, otherwise fallback to parent media files
                const childPhotoFiles = promoItem?.mediaFiles?.filter((file) => file?.isQuality === false) || [];
                const parentPhotoFiles = promoItem?.parentMediaFiles?.filter((file) => file?.isQuality === false) || [];
                const photoFiles = childPhotoFiles.length > 0 ? childPhotoFiles : parentPhotoFiles;
                return photoFiles.map((file) => ({
                  type: "image",
                  thumbnail: file.url,
                  src: file.url,
                }));
              })()}
            /> */}
            {/* <PUIContentCarousel
              data={(() => {
                const childPhotoFiles =
                  promoItem?.mediaFiles?.filter(
                    (file) =>
                      file?.isQuality === false &&
                      file?.mimeType?.startsWith("image/")
                  ) || [];

                const parentPhotoFiles =
                  promoItem?.parentMediaFiles?.filter(
                    (file) =>
                      file?.isQuality === false &&
                      file?.mimeType?.startsWith("image/")
                  ) || [];

                const photoFiles =
                  childPhotoFiles.length > 0
                    ? childPhotoFiles
                    : parentPhotoFiles;

                return photoFiles.map((file) => ({
                  type: "image",
                  thumbnail: file.url,
                  src: file.url,
                }));
              })()}
            /> */}
            <PUIContentCarousel
              data={(() => {
                // const childPhotoFiles =
                //   promoItem?.mediaFiles?.filter(
                //     (file) =>
                //       file?.isQuality === false &&
                //       file?.mimeType?.startsWith("image/")
                //   ) || [];
                const childPhotoFiles =
                  promoItem?.mediaFiles?.filter(
                    (file) => file?.isQuality === false
                  ) || [];

                // const parentPhotoFiles =
                //   promoItem?.parentMediaFiles?.filter(
                //     (file) =>
                //       file?.isQuality === false &&
                //       file?.mimeType?.startsWith("image/")
                //   ) || [];
                const parentPhotoFiles =
                  promoItem?.parentMediaFiles?.filter(
                    (file) => file?.isQuality === false
                  ) || [];

                const photoFiles =
                  childPhotoFiles.length > 0
                    ? childPhotoFiles
                    : parentPhotoFiles;

                const slides = photoFiles.map((file) => ({
                  type: file?.mimeType === "application/pdf" ? "pdf" : "image",
                  thumbnail: file.url,
                  src: file.url,
                  fileName:
                    file.originalFileName ||
                    file.fileName ||
                    file.name,
                }));

                console.log("slides", slides);
                console.log("photoFiles", photoFiles);

                return slides;
              })()}
            />
          </Box>
          <Breadcrumbs
            sx={{ my: 2 }}
            separator={<NavigateNext fontSize="small" />}
            aria-label="breadcrumb"
          >
            {[
              <NavLink key="1" color="inherit" to="/browse" onClick={() => { }}>
                Browse
              </NavLink>,
              <NavLink
                key="1"
                color="inherit"
                to={`/browse?catId=${promoItem?.promoCategoryId}`}
                onClick={() => { }}
              >
                {
                  StaticResources.promoCategories.find(
                    (cat) => cat.id == promoItem?.promoCategoryId
                  )?.name
                }
              </NavLink>,
            ]}
          </Breadcrumbs>

          <Box sx={{ display: "flex", alignItems: "center", maxWidth: "100%" }}>
            <Tooltip title={promoItem?.shortDescription || ""}>
              <Typography
                variant="h6"
                noWrap={!isMobile || !materialDescriptionExpanded}
                sx={{
                  fontWeight: "bold",
                  flex: 1,
                  minWidth: 0,
                  overflowWrap: materialDescriptionExpanded ? "anywhere" : "normal",
                }}
              >
                {promoItem?.shortDescription}
              </Typography>
            </Tooltip>
            {isMobile && (
              <IconButton
                size="small"
                aria-label={
                  materialDescriptionExpanded
                    ? "Show less material description"
                    : "Show full material description"
                }
                onClick={() =>
                  setMaterialDescriptionExpanded(!materialDescriptionExpanded)
                }
              >
                <ExpandMoreIcon
                  sx={{
                    transform: materialDescriptionExpanded
                      ? "rotate(180deg)"
                      : "none",
                  }}
                />
              </IconButton>
            )}
          </Box>

          <Tooltip
            title={`${promoItem?.materialNumber || ""} | ${
              promoItem?.detailedDescription || ""
            }`}
          >
            <Typography
              variant="body1"
              noWrap={!isMobile || !materialDescriptionExpanded}
              sx={{
                mt: 1,
                maxWidth: "100%",
                overflowWrap: materialDescriptionExpanded ? "anywhere" : "normal",
              }}
            >
              {promoItem?.materialNumber} | {promoItem?.detailedDescription}
            </Typography>
          </Tooltip>

          <Typography variant="body2">
            {/* {promoItem?.pslIdWithPrefix} */}
            {/* {promoItem?.marketLocation
    ? ` | ${promoItem.marketLocation}`
    : ""} */}
          </Typography>

          <Typography variant="body1" sx={{ mt: 1 }}>{promoItem?.supplierName}</Typography>
          <Grid container spacing={2} sx={{ py: 6 }}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Table>
                  <TableBody>
                    {[{
                      name: "Note to Requester",
                      value: promoItem?.noteRequester?.trim() || "-",
                    },
                    {
                      name: "Catalogue ID",
                      value: `${promoItem?.pslIdWithPrefix}${promoItem?.markets?.length
                        ? ` | ${promoItem.markets[0].name}`
                        : ""
                        }`,
                    },
                    {
                      name: "Quantity",
                      value: (
                        <>
                          <TextField
                            value={quantity}
                            type={"number"}
                            variant={"standard"}
                            onChange={(e) => setQuantity(e.target.value)}
                            error={showQuantityError}
                            helperText={
                              showQuantityError
                                ? "Quantity must be greater than MOQ and multiple of MPQ"
                                : ""
                            }
                            inputProps={{
                              step: promoItem?.minimumPurchaseQuantity,
                            }}
                          />
                        </>
                      ),
                    },
                    {
                      name: "Order Window ID",
                      value: promoItem?.orderWindowIdWithPrefix,
                    },
                    {
                      name: "Supplier Part Id",
                      value: !promoItem?.supplierPartId ? null : (
                        <>
                          {promoItem?.supplierPartId}{" "}
                          <BarcodeButton
                            value={promoItem?.supplierPartId}
                          />
                        </>
                      ),
                    },
                    {
                      name: "Manufacturer Part Number",
                      value: !promoItem?.manufacturerPartNumber ? null : (
                        <>
                          {promoItem?.manufacturerPartNumber}{" "}
                          <BarcodeButton
                            value={promoItem?.manufacturerPartNumber}
                          />
                        </>
                      ),
                    },
                    {
                      name: "Status",
                      value: promoItem?.statusName,
                    },
                    {
                      name: "Price Ranges",
                      value: "Price Ranges",
                    },
                    {
                      name: "MOQ",
                      value: promoItem?.minimumOrderQuantity,
                    },
                    {
                      name: "MPQ",
                      value: promoItem?.minimumPurchaseQuantity,
                    },
                    {
                      name: "Supplier Lead Time",
                      value:
                        promoItem?.supplierLeadTime != null
                          ? `${promoItem.supplierLeadTime} day(s)`
                          : null,
                    },
                    {
                      name: "IncoTerms",
                      value: promoItem?.incoTerms,
                    },

                    {
                      name: "Unit Price",
                      value: unitPrice,
                    },
                    {
                      name: "Currency",
                      value: promoItem?.currencyCode,
                    },
                    {
                      name: "Price Per",
                      value: pricePer,
                    },
                    {
                      name: "Unit of measure",
                      value: promoItem?.unitOfMeasure,
                    },
                    {
                      name: "Valid From",
                      value: moment(promoItem?.validFrom).format(
                        "DD/MM/YYYY"
                      ),
                    },
                    {
                      name: "Valid To",
                      value: moment(promoItem?.validTo).format("DD/MM/YYYY"),
                    },
                    {
                      name: "Agreements",
                      value: promoItem?.agreements,
                    },
                    {
                      name: "Tender Number",
                      value: promoItem?.tenderNumber,
                    },
                    {
                      name: "Strategic Buyer",
                      value: promoItem?.strategicBuyerEmailAddress,
                    },
                      // {
                      //   name: "Created By",
                      //   value: promoItem?.createdByUser?.email,
                      // },
                      // {
                      //   name: "Created On",
                      //   value: moment(promoItem?.createdOn).format(
                      //     "DD/MM/YYYY"
                      //   ),
                      // },
                      // {
                      //   name: "Modified By",
                      //   value: promoItem?.modifiedByUser?.email,
                      // },
                      // {
                      //   name: "Modified On",
                      //   value: moment(promoItem?.modifiedOn).format(
                      //     "DD/MM/YYYY"
                      //   ),
                      // },
                    ]
                      .filter((field) => {
                        return !!field.value || showEmptyFields;
                      })
                      .map((field) =>
                        field.name !== "Price Ranges" ? (
                          <TableRow key={field.name}>
                            {/* <TableCell>
                              <strong>{field.name}</strong>
                            </TableCell>
                            <TableCell>{field.value}</TableCell> */}
                            <TableCell
                              sx={{
                                py: 0.5,
                                px: 2,
                                width: "40%",
                                borderBottom: "1px solid rgba(224,224,224,1)",
                              }}
                            >
                              <strong>{field.name}</strong>
                            </TableCell>

                            <TableCell
                              sx={{
                                py: 0.5,
                                px: 2,
                                borderBottom: "1px solid rgba(224,224,224,1)",
                              }}
                            >
                              {field.value}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow
                            key={field.name}
                            style={{
                              borderBottom: "1px solid rgba(224, 224, 224, 1)",
                            }}
                          >
                            <TableCell colSpan={2} style={{ padding: 0 }}>
                              <Accordion
                                defaultExpanded={true}
                                sx={{
                                  borderRadius: 0,
                                  padding: 0,
                                  boxShadow: "none",
                                }}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  sx={{
                                    minHeight: 36,
                                    "&.Mui-expanded": {
                                      minHeight: 36,
                                    },
                                    "& .MuiAccordionSummary-content": {
                                      margin: "6px 0",
                                    },
                                    "& .MuiAccordionSummary-content.Mui-expanded": {
                                      margin: "6px 0",
                                    },
                                    fontSize: "0.875rem",
                                    fontWeight: "400",
                                  }}
                                >
                                  <strong>{field.name}</strong>
                                </AccordionSummary>
                                <AccordionDetails
                                  sx={{
                                    p: 1,
                                    pt: 0,
                                  }}
                                >
                                  <Stack spacing={0}>
                                    <Table
                                      size="small"
                                      padding="none"
                                      sx={{
                                        "& .MuiTableCell-root": {
                                          py: 0.5,
                                          px: 1,
                                        },
                                      }}
                                    >
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Quantity</TableCell>
                                          <TableCell>Price</TableCell>
                                          <TableCell>PricePer</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        <>
                                          {promoItem.priceRanges
                                            ?.sort(
                                              (a, b) => a.quantity - b.quantity
                                            )
                                            ?.map((priceRange, index) => (
                                              <TableRow key={index}>
                                                <TableCell
                                                  sx={{
                                                    width: "35%",
                                                    borderBottom: "none",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      borderBottom:
                                                        "1px dotted rgba(224, 224, 224, 1)",
                                                    }}
                                                  >
                                                    <div>
                                                      {priceRange?.quantity}
                                                    </div>
                                                    <div>
                                                      {promoItem.unitOfMeasure}
                                                    </div>
                                                  </div>
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    width: "35%",
                                                    borderBottom: "none",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      borderBottom:
                                                        "1px dotted rgba(224, 224, 224, 1)",
                                                    }}
                                                  >
                                                    <div>
                                                      {priceRange?.price}
                                                    </div>
                                                    <div>
                                                      {promoItem.currencyCode}/
                                                      {promoItem.unitOfMeasure}
                                                    </div>
                                                  </div>
                                                </TableCell>
                                                <TableCell
                                                  sx={{
                                                    width: "20%",
                                                    borderBottom: "none",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      borderBottom:
                                                        "1px dotted rgba(224, 224, 224, 1)",
                                                    }}
                                                  >
                                                    <>{priceRange?.pricePer}</>
                                                  </div>
                                                </TableCell>
                                              </TableRow>
                                            ))}
                                        </>
                                      </TableBody>
                                    </Table>
                                  </Stack>
                                </AccordionDetails>
                              </Accordion>
                            </TableCell>
                          </TableRow>
                        )
                      )}
                  </TableBody>
                </Table>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        checked={showEmptyFields}
                        onChange={() => setShowEmptyFields(!showEmptyFields)}
                      />
                    }
                    label="Show Empty Fields"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </Drawer>
  );
};

export default PromoItemDetails;
